import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  PartnerAgentOwnerMarketingPageHeader,
  PartnerAgentOwnerMarketingPageFooter,
  PartnerAgentOwnerMarketingPageWhySunroom,
  PartnerAgentOwnerMarketingPageHowItWorks,
  PartnerAgentOwnerMarketingPagePropertyPerformance,
  PartnerAgentOwnerMarketingPageTestimonials,
  PartnerAgentOwnerMarketingPageFAQs,
} from 'client/components/PartnerAgentOwnerMarketingPage';

import SrBox from 'client/components/SrBox';

import branch from 'client/core/branch';
import withTransitionHook from 'client/helpers/withTransitionHook';
import PartnerActions from 'client/actions/Partner';

@withTransitionHook
@branch(({ match }) => {
  if (match.params.partnerId) {
    return {
      partner: ['partners', 'byId', match.params.partnerId],
    };
  }
})
class PartnerAgentOwnerMarketingPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Lease Your Property | Sunroom Rentals',
  })

  static fetchData(match, inject) {
    const partnerId = parseInt(match.params.partnerId, 10);

    if (partnerId) {
      return PartnerActions.getById(inject, {
        partnerId,
      });
    }
  }

  static propTypes = {
    partner: PropTypes.object,
  }

  render() {
    const { partner } = this.props;

    if (!partner) {
      return null;
    }

    return (
      <>
        <PartnerAgentOwnerMarketingPageHeader partner={partner} />
        <SrBox padding='0 20px'>
          <PartnerAgentOwnerMarketingPageWhySunroom />
          <PartnerAgentOwnerMarketingPageHowItWorks />
        </SrBox>
        <PartnerAgentOwnerMarketingPagePropertyPerformance />
        <SrBox padding='0 20px'>
          <PartnerAgentOwnerMarketingPageTestimonials />
          <PartnerAgentOwnerMarketingPageFAQs />
          <PartnerAgentOwnerMarketingPageFooter partner={partner} />
        </SrBox>
      </>
    );
  }
}

PartnerAgentOwnerMarketingPage.displayName = 'PartnerAgentOwnerMarketingPage';

export default PartnerAgentOwnerMarketingPage;
